import * as z from 'zod';
import { EntityId, Quantity, Tag } from '../base-schemas';
import { isoDateTimeToAppTime } from '../base-codecs';
/** Vad en lagerartikel gör just nu. `in_use` betyder incheckad och inte utcheckad. */
export const ReservableLiveUsageState = z.enum(['in_use', 'booked', 'unavailable', 'free']);
export const ReservableProductUsageItem = z.object({
    item_id: EntityId,
    quantity: Quantity,
    delivery_date_time: isoDateTimeToAppTime,
    return_date_time: isoDateTimeToAppTime,
    delivered_at: isoDateTimeToAppTime.nullable(),
    returned_at: isoDateTimeToAppTime.nullable(),
    customer_name: z.string().nullable(),
    booking_number: z.string().nullable(),
    reservable_ids: EntityId.array()
});
export const ReservableLiveUsage = z.object({
    id: EntityId,
    identifier: z.string(),
    is_available: z.boolean(),
    state: ReservableLiveUsageState,
    booking: ReservableProductUsageItem.nullable()
});
/**
 * Hur mycket av en produkt som används just nu. Kvantiteter är i tusendelar, som `stock_quantity`.
 * Kapaciteten är lagersaldot för poolprodukter och antalet lagerartiklar för individuellt spårade.
 */
export const ReservableProductLiveUsageResource = z.object({
    _tag: Tag('ReservableProductLiveUsageResource'),
    reservable_product_id: EntityId,
    is_individually_tracked: z.boolean(),
    capacity: Quantity,
    in_use: Quantity,
    booked_not_checked_in: Quantity,
    unavailable: Quantity,
    peak_in_use_last_day: Quantity,
    measured_at: isoDateTimeToAppTime,
    /** Tom för poolprodukter. */
    reservables: ReservableLiveUsage.array()
});
